import { render, staticRenderFns } from "./ondutyStudentList.vue?vue&type=template&id=13e79d5b&scoped=true&"
import script from "./ondutyStudentList.vue?vue&type=script&lang=js&"
export * from "./ondutyStudentList.vue?vue&type=script&lang=js&"
import style0 from "./ondutyStudentList.vue?vue&type=style&index=0&id=13e79d5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e79d5b",
  null
  
)

export default component.exports